import { BRAND_CEL, BRAND_RCI } from 'contexts/CruiseSearchContext/constants';

const imageSizes = {
  [BRAND_CEL.code]: {
    img: {
      small: '$24x13-small$',
      medium: '$16x9-med$',
      large: '$8x3-large$',
    },
  },
  [BRAND_RCI.code]: {
    img: {
      small: '$440x248$',
      medium: '$800x450$',
      large: '$1040x520$',
    },
  },
};

export default imageSizes;
